import React from 'react';
import { useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
const titleMap: {
  match: (p: string) => boolean;
  title: string;
}[] = [{
  match: p => p === '/',
  title: '仪表盘'
}, {
  match: p => p.startsWith('/chat') || p.startsWith('/sessions'),
  title: '对话'
}, {
  match: p => p.startsWith('/models'),
  title: '模型中心'
}, {
  match: p => p.startsWith('/skills'),
  title: 'Skills 中心'
}, {
  match: p => p.startsWith('/knowledge-bases'),
  title: '知识库中心'
}, {
  match: p => p === '/agents/new',
  title: '创建 Agent'
}, {
  match: p => p.includes('/edit'),
  title: '编辑 Agent'
}, {
  match: p => p.startsWith('/agents'),
  title: 'Agent 中心'
}, {
  match: p => p.startsWith('/tasks'),
  title: '任务面板'
}, {
  match: p => p.startsWith('/history-sessions'),
  title: '历史会话'
}, {
  match: p => p.startsWith('/history'),
  title: '历史记录'
}, {
  match: p => p.startsWith('/settings'),
  title: '系统设置'
}];
export function AppLayout({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    pathname
  } = useLocation();
  const title = titleMap.find(t => t.match(pathname))?.title || 'Agent 平台';
  return <div className="flex h-full w-full bg-slate-950 text-slate-200" data-id="element-234">
      <Sidebar data-id="element-235" />
      <div className="flex min-w-0 flex-1 flex-col" data-id="element-236">
        <Topbar title={title} data-id="element-237" />
        <main className="flex-1 overflow-y-auto" data-id="element-238">{children}</main>
      </div>
    </div>;
}